import { userConstants } from '../_constants';

let user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: false, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_CLEAR:
      return {};
    case userConstants.LOGIN_REQUEST:
      return {
        loggedIn: false,
        user: action.user,
        password: action.password
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
        password: state.password
      };
    case userConstants.LOGIN_FAILURE:
      return {
        loggedIn: false,
        user: null,
        error: { message: action.error.error, code: action.error.errorCode },
      };
    case userConstants.LOGOUT:
      return {};
    default:
      return state
  }
}